import { render, staticRenderFns } from "./buttonIcon-editor.vue?vue&type=template&id=20df78a2&scoped=true"
import script from "./buttonIcon-editor.vue?vue&type=script&lang=js"
export * from "./buttonIcon-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20df78a2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20df78a2')) {
      api.createRecord('20df78a2', component.options)
    } else {
      api.reload('20df78a2', component.options)
    }
    module.hot.accept("./buttonIcon-editor.vue?vue&type=template&id=20df78a2&scoped=true", function () {
      api.rerender('20df78a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/buttonIcon-editor.vue"
export default component.exports